import React from 'react'

import BaseModal from '@SonarCX/components/molecules/ChatModals/BaseModal2'

import { useBreakpoint } from '@SonarCX/providers/BreakpointProvider'
import useStyles from './styles'

export type CommonModalProps = {
  title: string
  onClose: () => void
  children: React.ReactNode
}

const CommonModal: React.FC<CommonModalProps> = ({
  title,
  onClose,
  children
}) => {
  const { isMedium } = useBreakpoint()

  const classes = useStyles()

  return (
    <BaseModal
      open
      title={title}
      onClose={e => {
        e.stopPropagation()
        onClose()
      }}
      PaperProps2={{
        style: {
          padding: '20px 16px 24px 16px',
          border: '1px solid #C6C6C6',
          borderRadius: '4px',
          width: isMedium ? 'calc(100% - 4rem)' : '100%',
          maxWidth: isMedium ? 'unset' : '480px',
          height: isMedium && `auto`,
          maxHeight: isMedium && 'unset',
          minHeight: isMedium && 'auto'
        }
      }}
      classes={{ title: classes.title, close: classes.close }}
    >
      {children}
    </BaseModal>
  )
}

export default CommonModal
